import QRCode from "react-qr-code";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Printer } from "lucide-react";

export const BookingSuccessDialog = ({ open, onClose, booking }) => {
  if (!booking) return null;
  const checkinUrl = `${window.location.origin}/checkin/${booking.reference}`;

  const printQR = () => {
    const w = window.open("", "_blank");
    if (!w) return;
    const doc = w.document;
    doc.title = booking.reference;

    // Safer DOM API instead of document.write to avoid XSS.
    const style = doc.createElement("style");
    style.textContent =
      "body{font-family:sans-serif;text-align:center;padding:40px}" +
      ".ref{font-size:28px;letter-spacing:.15em;margin:20px 0;font-weight:700}" +
      ".info{color:#555;margin:8px 0}" +
      "svg{max-width:280px;margin:20px auto;display:block}";
    doc.head.appendChild(style);

    const h1 = doc.createElement("h1");
    h1.textContent = "Hotel Due Pini Conte";
    doc.body.appendChild(h1);

    const ref = doc.createElement("div");
    ref.className = "ref";
    ref.textContent = booking.reference;
    doc.body.appendChild(ref);

    const roomInfo = doc.createElement("div");
    roomInfo.className = "info";
    roomInfo.textContent = booking.room_name || "";
    doc.body.appendChild(roomInfo);

    // Clone SVG QR node (safe: it's a react-qr-code generated SVG we already own)
    const qrNode = document.getElementById("booking-qr");
    if (qrNode) {
      doc.body.appendChild(qrNode.cloneNode(true));
    }

    const hint = doc.createElement("div");
    hint.className = "info";
    hint.textContent = "Inquadra il QR in reception per il check-in";
    doc.body.appendChild(hint);

    setTimeout(() => w.print(), 300);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="max-w-md"
        data-testid="booking-success-dialog"
      >
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
              <CheckCircle2 className="w-5 h-5 text-emerald-600" />
            </div>
            <DialogTitle className="font-display text-2xl">
              Prenotazione confermata
            </DialogTitle>
          </div>
          <DialogDescription>
            Conserva questo codice: presentalo in reception per un check-in
            rapido.
          </DialogDescription>
        </DialogHeader>

        <div className="bg-muted/50 rounded-xl p-6 text-center">
          <div className="text-[11px] uppercase tracking-[0.28em] text-muted-foreground mb-2">
            Riferimento
          </div>
          <div
            className="font-mono text-xl font-semibold text-primary mb-5"
            data-testid="success-reference"
          >
            {booking.reference}
          </div>
          <div className="bg-white p-4 inline-block rounded-lg">
            <QRCode
              id="booking-qr"
              value={checkinUrl}
              size={180}
              level="M"
              data-testid="booking-qr"
            />
          </div>
          <div className="text-xs text-muted-foreground mt-4">
            {booking.room_name}
          </div>
        </div>

        <div className="flex gap-2">
          <Button
            onClick={printQR}
            variant="outline"
            className="pill flex-1"
            data-testid="print-qr"
          >
            <Printer className="w-4 h-4 mr-2" />
            Stampa
          </Button>
          <Button
            onClick={onClose}
            className="btn-primary pill flex-1"
            data-testid="close-success"
          >
            Chiudi
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
